export default function TabSelector({ isActive, children, onClick }) {
  return (
    <button
      className={`group inline-flex items-center px-2 py-4 border-b-2 font-semibold text-sm leading-5 cursor-pointer whitespace-nowrap ${
        isActive
          ? 'border-green text-green focus:outline-none focus:text-green focus:border-green'
          : 'border-transparent text-gray-500 hover:text-gray-600 hover:border-gray-300 focus:text-gray-600 focus:border-gray-300'
      }`}
      onClick={onClick}
    >
      {children}
    </button>
  )
}
